import { Helmet } from 'react-helmet-async';
import '../../assets/styles/ERP.css'
import erpOverviewImg from "../../assets/images/frontend.jpeg";
import inventoryImg from "../../assets/images/backend.png";
import financeImg from "../../assets/images/fullstackdeveloper.png";
import hrImg from "../../assets/images/ecommercedevelopment.jpg";
import manufacturingImg from "../../assets/images/mobileappdevelopment.png";
import integrationImg from "../../assets/images/main_banner.png";

const ERP = () => {

  return (
    <>
    <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> ERP Software – BuddyTech Solutions </title>
        <meta name="description" content="Enterprise resource planning for finance, HR, inventory and project control." />
        <meta name="keywords" content="ERP system, ERP software" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="ERP Software – BuddyTech Solutions" />
        <meta property="og:description" content="Enterprise resource planning for finance, HR, inventory and project control." />
        <meta property="og:keywords" content="ERP system, ERP software" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/products/erp" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ERP Software – BuddyTech Solutions" />
        <meta name="twitter:description" content="Enterprise resource planning for finance, HR, inventory and project control." />
        <meta name="twitter:keywords" content="ERP system, ERP software" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
    <div className="erp-container">
      <header className="erp-hero">
        <h1>Enterprise Resource Planning (ERP)</h1>
        <p>Streamline and optimize your operations with a centralized ERP system designed to scale with your business.</p>
      </header>

      <section className="erp-overview">
        <div className="erp-overview-text">
          <h2>Comprehensive ERP Solutions</h2>
          <p>
            Our ERP platform provides end-to-end visibility and control over your resources, allowing for efficient data-driven decision-making across finance, HR, inventory, and operations.
          </p>
          <ul>
            <li>Unified control center for all business operations</li>
            <li>Real-time data synchronization across departments</li>
            <li>Custom workflows and role-based dashboards</li>
            <li>Cloud and on-premise deployment options</li>
            <li>Seamless third-party integrations</li>
          </ul>
        </div>
        <img src={erpOverviewImg} alt="ERP Overview" className="erp-overview-img" />
      </section>

      <section className="erp-features">
        <h2>Key ERP Modules</h2>
        <div className="erp-feature-grid">
          <div className="erp-feature-card">
            <img src={inventoryImg} alt="Inventory Management" />
            <h3>Inventory Management</h3>
            <p>Track stock levels, shipments, and inventory movements in real time.</p>
          </div>

          <div className="erp-feature-card">
            <img src={financeImg} alt="Finance & Accounting" />
            <h3>Finance & Accounting</h3>
            <p>Automate billing, ledger entries, expense tracking, and financial reporting.</p>
          </div>

          <div className="erp-feature-card">
            <img src={hrImg} alt="HR & Payroll" />
            <h3>HR & Payroll</h3>
            <p>Manage employee records, attendance, payroll, and appraisals in one place.</p>
          </div>

          <div className="erp-feature-card">
            <img src={manufacturingImg} alt="Manufacturing" />
            <h3>Manufacturing</h3>
            <p>Plan, track, and optimize production with MRP tools and BOM management.</p>
          </div>

          <div className="erp-feature-card">
            <img src={integrationImg} alt="Integrations" />
            <h3>Integrations</h3>
            <p>Integrate seamlessly with CRM, eCommerce, banking, and third-party APIs.</p>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default ERP
